<div #modal class="modal fade" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable" (change)="toggleOnChange()">
    <ng-template #container></ng-template>
  </div>
</div>

<div class="d-none">
  <ng-template #stackContainer></ng-template>
</div>
